import { ResponseParams, requestHttpGet, requestHttpPut, ApiError } from './RequestBase';

export type PeriodicPaymentToken = {
	periodic_payment_id: string; // 定期購読ID
	payment_id?: string; // PayPalPaymentID
	agreement_id?: string; // PayPalAgreementID
	site_cd?: string; // サービスサイトコード
	site_name?: string; // サイトリスト名
	payment_type?: string; // 支払区分
	first_capture_date?: Date; // 初回決済日
	last_capture_date?: Date; // 最新決済日
};

// 定期購読一覧取得
export type GetPeriodicPaymentResData = {
	periodic_payments?: PeriodicPaymentToken[];
};

export const callGetPeriodicPaymentApi = async (): Promise<ResponseParams<GetPeriodicPaymentResData>> => {
	const result: ResponseParams<GetPeriodicPaymentResData> = await requestHttpGet(`/users/periodic-payment`);
	return result;
};

export type PeriodicPaymentDetailToken = {
	periodic_payment_id: string; // 定期購読ID
	payment_id?: string; // PayPalPaymentID
	agreement_id?: string; // PayPalAgreementID
	site_cd?: string; // サービスサイトコード
	site_name?: string; // サイトリスト名
	payment_type?: string; // 支払区分
	first_capture_date?: Date; // 初回決済日
	last_capture_date?: Date; // 最新決済日
	expiry?: string; // 有効期限
	brand?: string; // カード種類
	last_digits?: string; // カード番号下4桁
	paypal_email?: string; // PayPalメールアドレス
	paypal_payer_id?: string; // PayPalアカウントID
	payment_specify_list?: {
		paypal_hidden_flg?: number; // PayPal非表示フラグ
		credit_hidden_flg?: number; // クレジットカード非表示フラグ
		deferred_hidden_flg?: number; //後払い非表示フラグ
	}; // 非表示支払方法
	site_settlement_setting_display_flg?: {
		paypal_display_flg?: number; // PayPal非表示フラグ
		credit_card_display_flg?: number; // クレジットカード非表示フラグ
		pay_after_display_flg?: number; //後払い非表示フラグ
	}; // 非表示支払方法
};

// 定期購読詳細取得
export type GetPeriodicPaymentDetailResData = PeriodicPaymentDetailToken;

export const callGetPeriodicPaymentDetailApi = async (
	periodic_payment_id: string,
): Promise<ResponseParams<GetPeriodicPaymentDetailResData>> => {
	const result: ResponseParams<GetPeriodicPaymentDetailResData> = await requestHttpGet(
		`/users/periodic-payment/${periodic_payment_id}`,
	);
	return result;
};

// 定期購読支払情報変更
type ChangePeriodicPaymentReqData = {
	paypal_order_id?: string;
	periodic_payment_id: string;
	payment_tokens_id?: string;
	agreement_id?: string;
};
export const callChangePeriodicPaymentApi = async (
	body: ChangePeriodicPaymentReqData,
): Promise<ResponseParams<void | ApiError>> => {
	const result: ResponseParams<void | ApiError> = await requestHttpPut(`/users/periodic-payment`, body);
	return result;
};
